import React, { useState } from 'react';
import { DefaultButton, Icon, Separator, TooltipHost } from '@fluentui/react';
import { PowerAppBaseType } from '../../../GlobalConst/globalEnums';

const SolutionComponents = ({solution, showByDefault, headerText = null}) => {

    const [showGroup, setShowGroup] = useState(showByDefault)

    const managedSolutionIcon = (solution) => 
        <TooltipHost content={solution.isManagedSolution ? 'Managed solution' : 'Unmanaged solution'} styles={iconStyles}>
            <Icon iconName={solution.isManagedSolution ? 'lockSolid' : 'unlock'} style={managedSolutionIconStyles} />
        </TooltipHost>

    const renderEnvironment = (solution) => 
        <div className='solutionComponents-rowStyles'>
            <div className='solutionComponents-envRowHeader'>Solution version: {solution.version}</div>
            <div className='solutionComponents-envBtn'><DefaultButton href={solution.url} target='_blank' styles={btnStyles}>Open solution</DefaultButton></div>
        </div>

    const renderApps = (solution) => {
        const apps = solution.apps.filter(x => x.type === PowerAppBaseType.powerApp)
        return (
            <div>
                <div className='solutionComponents-rowStyles'>
                    <div className='solutionComponents-itemRowHeader solutionComponents-itemNameRow'>App name</div>
                    <div className='solutionComponents-itemRowHeader solutionComponents-itemTypeRow'>App type</div>
                    <div className='solutionComponents-itemBtn'></div>
                </div>
                {apps.map(x => renderAppRow(x))}
            </div>
        )
    }

    const renderFlows = (solution) => {
        const flows = solution.apps.filter(x => x.type === PowerAppBaseType.flow)
        return (
            <div>
                <div className='solutionComponents-rowStyles'>
                    <div className='solutionComponents-itemRowHeader solutionComponents-itemNameRow'>Flow name</div>
                    <div className='solutionComponents-itemRowHeader solutionComponents-itemTypeRow'>Flow state</div>
                    <div className='solutionComponents-itemBtn'></div>
                </div>
                {flows.map(x => renderFlowRow(x))}
            </div>
        )
    }
    
    const renderSupportingSolutions = (solution) => {
        return (
            <div>
                <div className='solutionComponents-rowStyles'>
                    <div className='solutionComponents-itemRowHeader solutionComponents-itemNameRow'>Supporting Solution</div>
                    <div className='solutionComponents-itemRowHeader solutionComponents-itemTypeRow'>Version</div>
                    <div className='solutionComponents-itemBtn'></div>
                </div>
                {solution.supportingSolutions.map(x => renderSupportingSolutionRow(x))}
            </div>
        )
    }

    const renderAppRow = (app) => 
        <div key={app.id} className='solutionComponents-rowStyles'>
            <div className='solutionComponents-itemNameRow'>{app.name}</div>
            <div className='solutionComponents-itemTypeRow'>{app.appType}</div>
            <div className='solutionComponents-itemBtn'>{app.playUrl && <DefaultButton href={app.playUrl} target='_blank' styles={btnStyles}>Play</DefaultButton>}</div>
        </div>

    const renderFlowRow = (flow) =>
        <div key={flow.id} className='solutionComponents-rowStyles'>
            <div className='solutionComponents-itemNameRow'>{flow.name}</div>
            <div className='solutionComponents-itemTypeRow'>{flow.state}</div>
            <div className='solutionComponents-itemBtn'><DefaultButton href={flow.playUrl} target='_blank' styles={btnStyles}>Open</DefaultButton></div>
        </div>

    const renderSupportingSolutionRow = (solution) =>
        <div key={solution.id} className='solutionComponents-rowStyles'>
            <div className='solutionComponents-itemNameRow'>{solution.name}</div>
            <div className='solutionComponents-itemTypeRow'>{solution.version}</div>
            <div className='solutionComponents-itemBtn'><DefaultButton href={solution.url} target='_blank' styles={btnStyles}>Open</DefaultButton></div>
        </div>

    return (
        <div style={{height: '100%', margin: '15px 0'}}>
            <div style={containerStyles}>
                <div style={headerStyles} onClick={() => setShowGroup(!showGroup)}>
                    <Icon iconName={showGroup ? 'ChevronUp' : 'ChevronDown'} style={iconStyles} /> 
                    {
                        headerText
                        ? headerText
                        : solution.environment.name
                    }
                    {managedSolutionIcon(solution)}
                </div>
                {
                    showGroup &&
                    <div style={itemsStyles}>
                        {renderEnvironment(solution)}
                        <Separator />
                        {renderApps(solution)}
                        <Separator />
                        {renderFlows(solution)}
                        <Separator />
                        {renderSupportingSolutions(solution)}
                    </div>
                }
            </div>
        </div>
    )
}

const containerStyles = {
    padding: '0 20px 20px 15px',
}

const itemsStyles = {
    margin: '20px 0 0 29px',
}

const iconStyles = {
    verticalAlign: 'middle',
    marginRight: 10
}

const headerStyles = {
    cursor: 'pointer',
    fontWeight: 800
}

const managedSolutionIconStyles = {
    marginLeft: 10,
    fontSize: 16
}

const btnStyles = {
    root: {
        width: '100%'
    }
}

export default SolutionComponents;


// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/SolutionComponents.js